module.exports = __webpack_public_path__ + "static/donate_company_logo03M@2x-0385bb44deb4c834243c3dc00f56ffe8.png";